import { Route, Routes as Router } from "react-router-dom";
import { ComingSoon } from "./components/ComingSoon";
import { EmployeeTags } from "./pages/employee-tags/employee-tags";
import { Employees } from "./pages/employees/Employees";
import { Home } from "./pages/home/Home";
import { Plans } from "./pages/plans/Plans";

export const Routes = () => {
  return (
    <Router>
      <Route path="/" Component={Home} />
      <Route path="/employees" Component={Employees} />
      <Route path="/reporting" Component={ComingSoon} />
      <Route path="/plans" Component={Plans} />
      <Route path="/billing" Component={ComingSoon} />
      <Route path="/employee-tags" Component={EmployeeTags} />
      <Route path="/account" Component={ComingSoon} />
    </Router>
  );
};
